export default __webpack_public_path__ + "static/Economic Model Whitepaper - Portuguese-a2a75b4b33ecca58117583b6522977a0.pdf";